import { CrudFilters } from "../../../../hooks/useCrudFilters";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../hooks/useTypedSelector";
import { TableFiltersWrapper } from "../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilters } from "../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilterInputWrapper } from "../../../general/table/modules/commons/tableFilters/tableFilters";
export const UserTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const nameSearchValue = getFilter("name", "contains") as string;
  const usernameSearchValue = getFilter("username", "contains") as string;
  const emailSearchValue = getFilter("email", "contains") as string;
  const statusValue = getFilter("status") as string;
  const rolesValue = getFilter("roles.name", "in") as string;
  const { t } = useTranslation("common");

  const currentUser = useAppSelector((state) => state.auth.user);

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={6}>
          <label>{t("Search")}</label>
          <Form.Control
            type="text"
            placeholder={t("Search")}
            value={
              usernameSearchValue ?? nameSearchValue ?? emailSearchValue ?? ""
            }
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("username");
                removeFilter("email");
                removeFilter("name");
              } else {
                updateFilter("username", value, "contains", undefined, "or");
                updateFilter("email", value, "contains", undefined, "or");
                updateFilter("name", value, "contains", undefined, "or");
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Search by roles")}</label>
          <Form.Select
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("roles.name");
              } else {
                updateFilter("roles.name", value, "in");
              }
            }}
            value={`${rolesValue ?? ""}`}
          >
            <option value={""}>{t("Select...")}</option>
            {currentUser.availableRoles.map((role) => {
              return (
                <option key={role} value={role}>
                  {t("user.role." + role)}
                </option>
              );
            })}
          </Form.Select>
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={3}>
          <label>{t("Search by status")}</label>
          <Form.Select
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("status");
              } else {
                updateFilter("status", value === "1");
              }
            }}
            value={`${statusValue ?? ""}`}
          >
            <option value={""}>{"- " + t("All") + " -"}</option>
            <option value={0}>{t("Inactive")}</option>
            <option value={1}>{t("Active")}</option>
          </Form.Select>
        </TableFilterInputWrapper>
      </TableFilters>

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
